import './category-card.html.twig';
import './category-card.scss';

export default function () {
  const currentWidth = window.matchMedia('(min-width: 1024px)');
  
  if ('IntersectionObserver' in window) {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          const image = entry.target.querySelector('.category-card__image');
          if (entry.isIntersecting && currentWidth.matches) {
            entry.target.classList.add('visible');
            image.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
    );

    const categoryCard = [...document.querySelectorAll('.category-card')];
    categoryCard.forEach((container) => {
      observer.observe(container);
    });
  }
}